export default __webpack_public_path__ + "static/media/m.ebb0c804.png";